module.exports = __webpack_public_path__ + "img/laptop-w-background-hires.68a21d6.webp";